// lib/apiConstants.js

export const BASE_URL = "https://sicunet.com";

export const API_URL = `${BASE_URL}/api`; // No trailing slash
export const UPLOADS_URL = `${BASE_URL}/uploads/`; // ← MUST have trailing slash!

export const getUploadUrl = (path = "") => {
  const cleanPath = path.replace(/^\/+/, ""); // Remove leading slashes
  return `${UPLOADS_URL}${cleanPath}`;
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return "";
  return `${BASE_URL}${imagePath.replace("static", "uploads")}`;
};

export const fetcher = async (endpoint) => {
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const url = `${API_URL}${cleanEndpoint}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }
  return response.json();
};
